import { createFileRoute } from '@tanstack/react-router'
import RoomDetailsPage from '@/features/rooms/components/room-details-page'

export const Route = createFileRoute(
  '/_authenticated/dashboard/rooms/$roomId',
)({
  component: RoomDetailsPage,
})
